"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tint = exports.shade = exports.mixColors = void 0;
var utils_1 = require("./utils/utils");
/**
 * Function for mixing hex colors
 * Sass mix for javascript
 * @param base hex color
 * @param color hex color
 * @param percentage amount of main colof in the mix
 * @returns string hex color
 */
function mixColors(base, color, percentage) {
    if (!utils_1.isColorValid(base) || !utils_1.isColorValid(color) || (!utils_1.isPercentageValid(percentage))) {
        return;
    }
    var percent = utils_1.normalizePercentage(percentage) / 100;
    var baseRGB = utils_1.toRGB(utils_1.normalizeColor(base));
    var colorRGB = utils_1.toRGB(utils_1.normalizeColor(color));
    var rbg = [
        percent * baseRGB[0] + (1 - percent) * colorRGB[0],
        percent * baseRGB[1] + (1 - percent) * colorRGB[1],
        percent * baseRGB[2] + (1 - percent) * colorRGB[2]
    ];
    return '#' + utils_1.toHEX(rbg[0]) + utils_1.toHEX(rbg[1]) + utils_1.toHEX(rbg[2]);
}
exports.mixColors = mixColors;
function shade(color, percentage) {
    return mixColors('000', color, percentage);
}
exports.shade = shade;
function tint(color, percentage) {
    return mixColors('fff', color, percentage);
}
exports.tint = tint;
